import { render } from "./TraceHeader.vue?vue&type=template&id=7813fd38&scoped=true"
import script from "./TraceHeader.vue?vue&type=script&lang=js"
export * from "./TraceHeader.vue?vue&type=script&lang=js"

import "./TraceHeader.vue?vue&type=style&index=0&id=7813fd38&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7813fd38"]])

export default __exports__